<template>
  <div class="news container html-content">
    <!--    <block-breadcrumbs />-->
    <h1 class="news-title">
      {{ pageTitle }}
    </h1>

    <div class="news-filter">
      <ui-segmented
        v-model="typeName"
        class="news-filter-segmented"
        :labels="['Все', 'Новости', 'Акции']"
      />

      <ui-select
        v-model="periodName"
        :options="computedSpecs"
        class="news-filter-select"
        @change="updatePublications"
      />
    </div>

    <div
      v-if="filteredPublications.length"
      class="news-publications"
    >
      <publication-card
        v-for="publication in filteredPublications"
        :key="publication.id"
        :info="publication"
        @click.native="openPublication(publication.id)"
      />
    </div>
    <page-info
      v-else
      title="Публикации не найдены"
    >
      Попробуйте поискать по другим разделам или
      <span @click="resetFilter">сбросить фильтры</span>
    </page-info>
  </div>
</template>

<script>
// import BlockBreadcrumbs from '../components/breadcrumbs/breadcrumbs';

import {mapActions, mapGetters} from 'vuex';
import PublicationCard from '../components/news/publication-card';
import PageInfo from '../components/common/page-info';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'news',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    PageInfo,
    PublicationCard,
    // BlockBreadcrumbs
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Новости и акции',
      typeName: 'Все',
      periodName: '',
    }
  },

  computed: {
    ...mapGetters({
      PUBLICATIONS: 'publications/publications',
      FILTER_SPECS: 'publications/dateRangeFilter'
    }),


    computedType() {
      switch (this.typeName) {
        case 'Акции':
          return 'promotion'
        case 'Новости':
          return 'news'
        default:
          return ''
      }
    },

    computedSpecs() {
      return this.FILTER_SPECS.map(spec => ({
        name: spec.name,
        dateRange: spec.dateRange,
        value: spec.name,
      }))
    },

    defaultPeriodName() {
      return this.computedSpecs[0].name || '';
    },

    filteredPublications() {
      return this.PUBLICATIONS.filter(({type}) => this.computedType ? type === this.computedType : true);
    }
  },

  created() {
    if (!this.$isServer) {
      this.periodName = this.defaultPeriodName;
    }
  },

  methods: {
    ...mapActions({
      LOAD_PUBLICATIONS: 'publications/loadPublications'
    }),

    openPublication(id) {
      window.location = `/news/${id}`;
    },

    updatePublications({name, dateRange}) {
      this.periodName = name;
      this.LOAD_PUBLICATIONS({dateRange});
    },

    resetFilter() {
      this.LOAD_PUBLICATIONS().then(() => {
        this.periodName = this.defaultPeriodName;
      });
    }
  },


  serverPrefetch() {
    return this.LOAD_PUBLICATIONS();
  }
};
</script>

<style lang="scss">
.news {
  &-title {
    margin-top: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid $gray_lu;
  }

  &-publications {
    .publication-card:nth-of-type(-n + 2) {
      height: 250px;

      .publication-card-image {
        display: block;
        height: 100%;
      }

      .publication-card-info {
        display: none;
      }
    }
  }

  &-filter {
    margin-top: 24px;

    &-select {
      margin-top: 16px;
    }

    &-segmented {
      .tab {
        min-width: 90px;
      }
    }
  }

  .page-info {
    span {
      color: $blue;
      cursor: pointer;
    }
  }
}

@include breakpoint("tablet") {
  .news {
    &-filter {
      display: flex;
      justify-content: space-between;

      &-select {
        min-width: 200px;
        margin-top: 0;
      }
    }

    &-publications {
      display: flex;
      flex-wrap: wrap;

      .publication-card {
        width: calc(33% - 9px);
        margin-right: 16px;

        &:nth-of-type(3n + 2) {
          margin-right: 0;
        }

        &:nth-of-type(-n + 2) {
          width: calc(50% - 8px);
          height: 298px;
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .news {
    &-title {
      margin-top: 32px;
      padding-bottom: 16px;
    }

    &-publications {
      .publication-card {
        width: calc(33% - 13px);
        margin-right: 24px;

        &:nth-of-type(-n + 2) {
          width: calc(50% - 12px);
          height: 520px;
        }
      }
    }
  }
}
</style>
